<template>
  <div class="configAuth">
      <div class="currentTag">
          <div>信息</div>
          <div><i style="font-size:22px;cursor:pointer" class="el-icon-close" @click="$emit('update:authOrConfig','')"></i></div>
      </div>
      <div class="content">
        <div class="contentTitle">
          商家公众号设置
        </div>
        <div class="configPanel">
          <el-form ref="publicNumConfigForm" :rules="rules" :model="publicNumFormData" label-width="118px">
              <el-form-item label="公众号名称" prop='publicNumName'>
                <el-autocomplete
                    class="matchInput"
                    v-model="publicNumFormData.publicNumName"
                    :fetch-suggestions="queryPublicNumSearch"
                    placeholder="请输入商家的公众号信息"
                    @select="handlePublicNumSelect"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="appId" prop='appId'>
                <el-input v-model="publicNumFormData.appId" placeholder="请填写微信公众平台后台的AppId"></el-input>
              </el-form-item>
              <el-form-item label="appSecret" prop='appSecret'>
                <el-input v-model="publicNumFormData.appSecret" placeholder="请填写微信公众平台后台的AppSecret"></el-input>
              </el-form-item>
              <el-form-item label="token" prop='token'>
                <el-input v-model="publicNumFormData.token" placeholder="请填写微信公众平台后台的对接服务器的token值"></el-input>
              </el-form-item>
              <el-form-item label="服务器配置说明" prop='description'>
                <el-input v-model="publicNumFormData.description" placeholder="请填写微信公众平台后台的对接服务器的参数"></el-input>
              </el-form-item>
              <el-form-item label="ip白名单配置" prop='ipWhiteList'>
                <el-input v-model="publicNumFormData.ipWhiteList" placeholder="请填写微信公众平台后台的ip白名单配置"></el-input>
              </el-form-item>
              <el-form-item label="上传JS文件" prop='fileJS'>
                <el-button type="primary" icon="el-icon-upload" @click="uploadJS()">上传文件</el-button>
              </el-form-item>
              <el-form-item label="">
                <div class="footBtn">
                    <el-button type='primary' @click="commitInfo()">提交</el-button><el-button type='primary' @click="backConfig()">返回配置</el-button>
                </div>
              </el-form-item>
          </el-form>
        </div>
      </div>
  </div>
</template>

<script>
  import api from '../../../config/api';

  export default {
    data(){
        let authInfo=this.authInfo;
        return{
          publicNumNameText:'',
          publicNumFormData:{
              publicNumName:authInfo.name,
              appId:authInfo.appId,
              appSecret:authInfo.appSecret,
              token:authInfo.token,
              description:'蛤科的合法化士大夫看见哈迪斯客户付款就',
              ipWhiteList:'192.168.13.2',
              fileJS:''
          },
          rules:{
              publicNumName:[
                  {required:true,message:'这个是必填的'}
              ],
              appId:[
                  {required:true,message:'必填'}
              ],
              appSecret:[
                  {required:true,message:'必填'}
              ],
              token:[
                  {required:true,message:'必填'}
              ],
              description:[
                  {required:true,message:'必填'}
              ],
              ipWhiteList:[
                  {required:true,message:'必填'}
              ],
              fileJS:[
                  {required:true,message:'必填'}
              ]
          }
        }
    },
    props:['authInfo'],
    created(){
        //创建input文件框
        this.inputNode=document.createElement('input');
        this.inputNode.type='file';
        console.log('传过来的值',this.authInfo)
    },
    methods:{
        backConfig(){
          this.$emit('update:authOrConfig','');
          this.$emit('backConfigRefresh');
        },
        commitInfo(){
          // 文件选中信号
          if(this.inputNode.files.length){
            this.publicNumFormData.fileJS='yes';
          }else{
            this.publicNumFormData.fileJS = '';
          }
          let data={
            name:this.publicNumFormData.publicNumName,
            appId:this.publicNumFormData.appId,
            appSecret:this.publicNumFormData.appSecret,
            token:this.publicNumFormData.token,
          }
          this.$refs.publicNumConfigForm.validate((valid)=>{
              console.log('验证结果',valid);
              if(valid){
                const loading=this.$loading();
                let url=api.system.publicNumConfigUpdate;
                this.$axios.fetchPost(url,data).then((res)=>{
                    console.log('查询配置信息',res)
                    loading.close();
                    if(res.code===200){
                      this.$notify({
                        type: "success",
                        title: '更改配置操作',
                        message: '成功',
                        showClose: false,
                      });
                      // this.$message({
                      //   message:'更改配置成功！',
                      //   type:'success'
                      // })
                    }else{
                      this.$notify({
                        type: "error",
                        title: '更改配置操作',
                        message: '失败',
                        showClose: false,
                      });
                      // this.$message,error('更改公众号配置信息失败！');
                    }
                })
              }
          })
        },
        uploadJS(){
          this.inputNode.click();
        },
        queryPublicNumSearch(queryString, cb){
          console.log('选择词',queryString)
          cb([{value:'第一个输入建议',id:'00A'},{value:'第二个输入建议',id:'00B'}])
        },
        handlePublicNumSelect(item){
          console.log(this.publicNumNameText,'选择了',item)
        }

    }

}
</script>

<style scoped>
.configAuth .currentTag{
    height: 43px;
    line-height: 42px;
    padding: 0px 20px 0px 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
}

.configAuth .content{
    width: 100%;
    height: calc(100vh - 103px);
    background-color: #ffffff;
    padding-left: 20px;
    box-sizing: border-box;
}
.content .contentTitle{
    height: 58px;
    border:1px solid #dddddd;
    line-height: 52px;
    width: 50%;

    color:#4D4D4D;
    font-size: 20px;
    padding-left: 62px;
}
.content .configPanel{
    width: 50%;
    height:500px;
    border:1px solid #dddddd;
    padding: 35px;
}
.content .el-input,.el-select{
    width: 308px;
}
.content .el-autocomplete .el-input{
    width: 308px;
}
.content .matchInput>>>.el-input{
    width: 308px;
}
</style>



// WEBPACK FOOTER //
// src/page/system/wechat/ConfigAuth.vue